import {
  useContext,
  createContext,
  ReactNode,
  useState,
  useCallback,
} from 'react';

import { useDragAndDrop } from '../components/shared/DragAndDrop/hook/dragAndDrop';

interface IGroupsProviderProps {
  children: ReactNode;
}

type Field = {
  id: string;
  name: string;
};

type GroupsContextData = {
  fields: Field[];
  dropField: () => void;
  removeField: (value: Field) => void;
  clearFields: () => void;
};

const GroupsContext = createContext({} as GroupsContextData);

export function GroupsProvider({ children }: IGroupsProviderProps) {
  const { field } = useDragAndDrop();
  const [fields, setFields] = useState<Field[]>([]);

  const dropField = useCallback(() => {
    const value = field;
    const hasFields = fields.filter(field => field.id === value.id).length > 0;
    if (!hasFields) {
      setFields(state => [...state, value]);
    }
  }, [fields, field]);

  const removeField = useCallback(
    (value: Field) => {
      const newFields = fields.filter(field => field.id !== value.id);
      setFields(newFields);
    },
    [fields],
  );

  // Remover tudo
  const clearFields = useCallback(() => {
    setFields(() => []);
  }, []);

  return (
    <GroupsContext.Provider
      value={{ fields, dropField, removeField, clearFields }}
    >
      {children}
    </GroupsContext.Provider>
  );
}

export const useGroups = () => useContext(GroupsContext);
